<div class="At-Wrapper">
    <section class="At-SectionLogin">
        <div class="container-fluid p-0">
            <div class="row no-gutters">
                <div class="col-md-5 at_Mainlogin At-CustomCol-47 d-flex align-items-center justify-content-center">
                    <div class="At-LoginFormGeneral At-LoginFormLoginPage">
                        <div class="At-ImgHolder At-ImgHolderLoginLogo">
                            <i class="icon-logo"></i>
                        </div>
                        <h2>Welcome Back</h2>
                        <h5>Sign in to continue</h5>
                        <form class=" ">
                            <div class="form-group ">
                                <div class="At-InputIcon At-InputIconSuccess">
                                    <i class="icon-tick-1"></i>
                                    <input id="userName" class="form-control " placeholder="jonathan.smith@gmail.com">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="At-InputIcon">
                                    <i class="icon-eye"></i>
                                    <input type="password" class="form-control" id="idPassword"
                                        aria-describedby="emailHelp" placeholder="Password">
                                </div>
                            </div>
                            <div class="form-group mb-5">
                                <a class="At-ForgotPassword" routerLink="/forgot-password">Forgot Password?</a>
                            </div>
                            <div class="form-group">
                                <button class="At-Btn" routerLink="/dashboard">SIGN IN </button>
                            </div>
                            <div class="form-group At-SignWithHeading">
                                <p>OR SIGN IN WITH</p>
                            </div>
                            <div class="form-row align-items-center At-LoginSocialBtns">
                                <div class="col-5">
                                    <button class="At-Btn"><i class="icon-facebook"></i>FACEBOOK </button>
                                </div>
                                <div class="col-5">
                                    <button class="At-Btn At-BtnWhite"><i class="icon-google"></i>GOOGLE </button>
                                </div>
                            </div>
                        </form>
                        <div class="At-DntHaveAccount">
                            <h6>Don’t have an account? <a  href="javascript:void(0);" routerLink="/create-account">CREATE ACCOUNT</a></h6>
                        </div>
                    </div>
                </div>
                <!-- at_Mainlogin ends -->

                <div class="col-md-7 At-BannerLogin At-CustomCol-53 d-flex align-items-center justify-content-center">
                    <div class="At-ImgHolder ">
                        <figure>
                            <img src="assets/images/login-right-bg.png" class="img-fluid" alt="">
                        </figure>
                    </div>
                    <a class="At-GetMobileAppLink" href="javascript:void(0);">GET YOUR MOBILE APP   >></a>
                </div>
                <!-- At-BannerLogin ends -->
            </div>
        </div>
    </section>
</div>
